import { useNavigate } from 'react-router-dom';

const AdminHeader = ({ onLogout, sectionTitle, onMenuClick }) => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = localStorage.getItem('isAdmin') === 'true';

  return (
    <>
      <header className="admin-header">
        <div className="admin-header-top">
          <div className="admin-header-left">
            <button
              type="button"
              className="admin-menu-btn"
              onClick={onMenuClick}
              aria-label="Abrir menú"
              aria-expanded={undefined}
            >
              <span className="admin-menu-icon" aria-hidden="true">☰</span>
            </button>
            <div className="admin-header-logo" onClick={() => navigate('/')} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && navigate('/')}>
              <div className="logo-icon">
                <img src="/achipo.jpg" alt="ACHIPO" className="logo-img" />
              </div>
              <div className="logo-text">
                <span className="logo-name">ACHIPO</span>
                <span className="logo-subtitle">
                  {sectionTitle ? `${sectionTitle}` : 'Panel Administrativo'}
                </span>
              </div>
            </div>
          </div>

          <div className="admin-header-actions">
            <button
              type="button"
              className="admin-back admin-back-long"
              onClick={() => navigate('/')}
              aria-label="Volver al sitio público"
            >
              ← Volver al sitio
            </button>
            <button
              type="button"
              className="admin-back admin-back-short"
              onClick={() => navigate('/')}
              aria-label="Volver al sitio público"
            >
              ← Volver
            </button>

            <div className="admin-user" aria-label={`Usuario: ${user?.username || user?.email || 'Admin'}`} title={user?.username || user?.email || 'Admin'}>
              <span className="admin-avatar" aria-hidden="true">{isAdmin ? '👑' : '👤'}</span>
              <span className="admin-name">{user?.username || user?.email || 'Admin'}</span>
            </div>

            <button
              type="button"
              className="admin-logout"
              onClick={onLogout}
              aria-label="Cerrar sesión"
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </header>

      <style>{`
        .admin-header {
          position: sticky;
          top: 0;
          z-index: 45;
          background: white;
          border-bottom: 1px solid #f0f0f0;
          padding: 0.5rem 0.75rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 0.5rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
          flex-shrink: 0;
        }
        @media (min-width: 769px) {
          .admin-header { padding: 0.75rem 2rem; gap: 1rem; }
        }

        .admin-header-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 0.5rem;
          width: 100%;
          flex-wrap: wrap;
        }
        @media (max-width: 480px) {
          .admin-header-top {
            flex-direction: column;
            align-items: stretch;
            gap: 0.5rem;
          }
        }

        .admin-back-long { display: none; }
        .admin-back-short { display: inline-block; }
        @media (min-width: 481px) {
          .admin-back-long { display: inline-block; }
          .admin-back-short { display: none; }
        }

        .admin-header-left {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          min-width: 0;
          flex: 1;
        }

        .admin-menu-btn {
          display: none;
          width: 40px;
          height: 40px;
          flex-shrink: 0;
          align-items: center;
          justify-content: center;
          border: 1px solid #eaeaea;
          background: #fff;
          border-radius: 8px;
          cursor: pointer;
          color: #1a4d8c;
          font-size: 1.25rem;
        }
        .admin-menu-btn:hover { background: #f5f8fc; }
        @media (max-width: 768px) {
          .admin-menu-btn { display: flex; }
        }

        .admin-header-logo {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          cursor: pointer;
          min-width: 0;
        }
        .logo-icon {
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          background: white;
          border: 1px solid #eaeaea;
        }
        @media (min-width: 769px) {
          .logo-icon { width: 36px; height: 36px; }
        }
        .logo-img { width: 100%; height: 100%; object-fit: contain; }

        .logo-text { display: flex; flex-direction: column; min-width: 0; }
        .logo-name { font-size: 1rem; font-weight: 700; color: #1a4d8c; line-height: 1.1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .logo-subtitle { font-size: 0.65rem; color: #666; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 120px; }
        @media (min-width: 769px) {
          .logo-name { font-size: 1.2rem; }
          .logo-subtitle { font-size: 0.75rem; max-width: none; }
        }

        .admin-header-actions {
          display: flex;
          align-items: center;
          gap: 0.4rem;
          flex-shrink: 0;
        }
        @media (max-width: 480px) {
          .admin-header-actions {
            justify-content: flex-end;
            flex-wrap: wrap;
            gap: 0.5rem;
          }
        }
        @media (min-width: 769px) { .admin-header-actions { gap: 1rem; } }

        .admin-back {
          background: none;
          border: 1px solid #eaeaea;
          color: #1a4d8c;
          padding: 0.4rem 0.5rem;
          border-radius: 6px;
          font-size: 0.7rem;
          cursor: pointer;
          transition: all 0.2s;
          white-space: nowrap;
        }
        @media (min-width: 480px) {
          .admin-back { padding: 0.45rem 0.75rem; font-size: 0.8rem; }
        }
        .admin-back:hover { background: #f5f8fc; }

        .admin-user {
          display: flex;
          align-items: center;
          gap: 0.4rem;
          background: #f8f9fa;
          border: 1px solid #eaeaea;
          padding: 0.35rem 0.5rem;
          border-radius: 6px;
          font-size: 0.8rem;
          color: #333;
          max-width: 100px;
          overflow: hidden;
        }
        @media (min-width: 480px) {
          .admin-user { max-width: 140px; }
        }
        @media (min-width: 769px) {
          .admin-user { padding: 0.4rem 0.75rem; font-size: 0.85rem; max-width: 180px; }
        }
        .admin-avatar { font-size: 0.9rem; flex-shrink: 0; }
        .admin-name { font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

        .admin-logout {
          background: #c62828;
          color: white;
          border: none;
          padding: 0.4rem 0.6rem;
          border-radius: 6px;
          font-size: 0.7rem;
          cursor: pointer;
          transition: background 0.2s;
          white-space: nowrap;
        }
        @media (min-width: 480px) {
          .admin-logout { padding: 0.45rem 0.9rem; font-size: 0.8rem; }
        }
        .admin-logout:hover { background: #b71c1c; }
      `}</style>
    </>
  );
};

export default AdminHeader;
